export default "__VITE_ASSET__DKeSvsTO__"